import React from "react";

const StatsSection = ({ cmsData }) => {
  return (
    <div className="stats-section py-5">
      <div className=" discover-stats-container">
        <div className="text-center mb-2">
          <h2 className="discover-title-stats mb-3">
            {cmsData?.hubzuDifference?.title || "Discover Hubzu"}
          </h2>
          <p className="text-muted discover-stats-subheading">
            Behind every number is a buyer, a seller, and a successful
            transaction on Hubzu.
          </p>
        </div>

        <div className="stats-card-container">
          <div className="row g-0">
            <div className="col-12 col-lg-3 col-md-6">
              <div className="stats-card text-center discover-hubzu-divider-bottom">
                <div className="discover-stats-number  mb-2">
                  {cmsData?.hubzuDifference?.businessCount}
                  <img
                    src="/assets/svg/home/DiscoverHubzuStats.svg"
                    className="mx-2"
                    alt={
                      cmsData?.hubzuDifference?.businessHeader ||
                      "Business statistics icon"
                    }
                  />
                </div>
                <p className="discover-stats-label  mb-0">
                  {cmsData?.hubzuDifference?.businessHeader}
                </p>
              </div>
            </div>

            <div className="col-12 col-lg-3 col-md-6">
              <div className="stats-card text-center discover-hubzu-divider discover-hubzu-divider-bottom">
                <div className="discover-stats-number  mb-2">
                  {cmsData?.hubzuDifference?.userCount}
                  <img
                    src="/assets/svg/home/DiscoverHubzuStats.svg"
                    className="mx-2"
                    alt={
                      cmsData?.hubzuDifference?.userHeader ||
                      "User statistics icon"
                    }
                  />
                </div>
                <p className="discover-stats-label  mb-0">
                  {cmsData?.hubzuDifference?.userHeader}
                </p>
              </div>
            </div>

            <div className="col-12 col-lg-3 col-md-6">
              <div className="stats-card text-center discover-hubzu-divider discover-hubzu-divider-bottom">
                <div className="discover-stats-number  mb-2">
                  {cmsData?.hubzuDifference?.propertySoldCount}
                  <img
                    src="/assets/svg/home/DiscoverHubzuStats.svg"
                    className="mx-2"
                    alt={
                      cmsData?.hubzuDifference?.propertySoldHeader ||
                      "Properties sold statistics icon"
                    }
                  />
                </div>
                <p className="discover-stats-label  mb-0">
                  {cmsData?.hubzuDifference?.propertySoldHeader}
                </p>
              </div>
            </div>

            <div className="col-12 col-lg-3 col-md-6">
              <div className="stats-card text-center discover-hubzu-divider discover-hubzu-divider-bottom">
                <div className="discover-stats-number  mb-2">
                  {cmsData?.hubzuDifference?.transactionsCount}
                  <img
                    src="/assets/svg/home/DiscoverHubzuStats.svg"
                    className="mx-2"
                    alt={
                      cmsData?.hubzuDifference?.transactionsHeader ||
                      "Transactions statistics icon"
                    }
                  />
                </div>
                <p className="discover-stats-label  mb-0">
                  {cmsData?.hubzuDifference?.transactionsHeader}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsSection;
